import React from "react";
import { useSelector } from "react-redux";
// Hooks
import { useAppDispatch } from "hooks/redux";
// Actions
import { PropertyOwnershipsActions } from "store/propertyOwnerships/propertyOwnershipsSlice";
// Selectors
import { selectParams } from "store/propertyOwnerships/propertyOwnershipsSelectors";
import { selectAllDestinationTypes } from "store/destinationTypes/destinationTypesSelectors";
// Models
import IDestinationType from "models/DestinationType";
// MUI
import {
  Box, Button, ButtonGroup, Checkbox, Divider,
  FormControlLabel, IconButton, Typography
} from "@mui/material";
import { makeStyles } from '@mui/styles';
import CloseIcon from '@mui/icons-material/Close';
// Utilities
import { getContent } from 'utilities/Utilities';

type Props = {
  onClose?: () => void,
}

const PropertyOwnershipFilters:React.FC<Props> = ({ onClose }) => {
  const classes = useStyles();
  const dispatch = useAppDispatch();

  const destinationTypes: IDestinationType[] = useSelector(selectAllDestinationTypes) || [];
  const params = useSelector(selectParams);

  const onChangeDestinationTypes = (event: any) => {
    const { name, checked } = event.target;
    const nextParams = {
      ...params,
      destinationTypesIds: params.destinationTypesIds ? checked ? [...params.destinationTypesIds, name] : params.destinationTypesIds.filter((destinationTypeId:any) => destinationTypeId !== name) : [name],
    }
    dispatch(PropertyOwnershipsActions.setParams(nextParams));
  }

  const onChangeCountBedrooms = (event: any) => {
    const { textContent } = event.target;
    const nextParams = {
      ...params,
      bedrooms: textContent.toLowerCase(),
    }
    dispatch(PropertyOwnershipsActions.setParams(nextParams));
  }

  return (
    <Box sx={{
      backgroundColor: '#fff', boxShadow: '0px 4px 32px rgba(0, 0, 0, 0.08)', border: '1px solid #eee', borderRadius: '8px',
      height: 'max-content', width: onClose ? '360px' : '100%'
    }}>
      <Box sx={{ display: 'flex', padding: '18px 24px' }}>
        <Typography className={classes.title}>Filters</Typography>
        <Box flexGrow="1" />
        {onClose && (
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <Divider />
      <Box sx={{ p: 3, display: 'flex', flexDirection: 'column' }}>
      <Typography className={classes.subtitle} sx={{ pb: 1 }}>{getContent('labels').labelDestinationTypeSingularText}</Typography>
        {destinationTypes.map((destinationType: IDestinationType) => (
          <FormControlLabel
            key={destinationType.id}
            control={
              <Checkbox
                id={`${destinationType.id}`}
                name={`${destinationType.id}`}
                checked={params.destinationTypesIds ? params.destinationTypesIds.includes(`${destinationType.id}`) : false}
                onChange={onChangeDestinationTypes}
              />
            }
            label={destinationType.name}
          />
        ))}
      </Box>
      <Divider />
      <Box sx={{ p: 3 }}>
        <Typography className={classes.subtitle} sx={{ pb: 1 }}>Bedrooms</Typography>
        <ButtonGroup variant="outlined" aria-label="outlined button group" onClick={onChangeCountBedrooms}>
          <Button variant={params.bedrooms === 'studio' ? 'contained' : 'outlined'}>Studio</Button>
          <Button variant={params.bedrooms === '1' ? 'contained' : 'outlined'}>1</Button>
          <Button variant={params.bedrooms === '2' ? 'contained' : 'outlined'}>2</Button>
          <Button variant={params.bedrooms === '3' ? 'contained' : 'outlined'}>3</Button>
          <Button variant={params.bedrooms === '4' ? 'contained' : 'outlined'}>4</Button>
        </ButtonGroup>
      </Box>
    </Box>
  )
}

export default PropertyOwnershipFilters;

const useStyles = makeStyles({
  title: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '160%',
    letterSpacing: '-0.35px',
    color: 'rgba(0, 0, 0, 0.87)',
  }, 
  subtitle: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '48px',
    letterSpacing: '-0.4px',
    color: 'rgba(0, 0, 0, 0.6)',
  }
});
